const prefix = "SAVED_SEARCH_";

export const SAVED_SEARCHES_GET = prefix + "SAVED_SEARCHES_GET";
export const PINNED_CRITERIA_GET = prefix + "PINNED_CRITERIA_GET";
export const PINNED_CRITERIA_SAVE = prefix + "PINNED_CRITERIA_SAVE";
export const SAVED_SEARCHES_SAVE = prefix + "SAVED_SEARCHES_SAVE";
